function returnForm() {
    var $cache = {};
    $cache.document = $(document);
    $cache.submitButton = $('#js-return-button');
    $cache.emailField = $('input[name$="emailAddress"]');
    $cache.orderNumberField = $('input[name$="orderNumber"]');


    // Function to check if both fields have values
    function checkFormValidity() {
        var emailValue = $cache.emailField.val();
        var orderNumberValue = $cache.orderNumberField.val();

        if (emailValue && emailValue.trim() !== '' && orderNumberValue && orderNumberValue.trim() !== '') {
            $cache.submitButton.attr('aria-disabled', 'false');
        } else {
            $cache.submitButton.attr('aria-disabled', 'true');
        }
    }

    // Listen for input changes on both fields
    $cache.document.on('input keyup', 'input[name$="emailAddress"], input[name$="orderNumber"]', function() {
        checkFormValidity();
    });

    // Initial check in case fields are pre-filled
    checkFormValidity();


}

function initializeCaptcha($wrapper) {
    if (SitePreferences.CONTACTUS_CAPTCHA_ENABLED) {
        // Explicit rendering reCAPTCHA
        window.grecaptcha.ready(() => {
            window.grecaptcha.render('g-recaptcha', {
                'sitekey' : SitePreferences.CONTACTUS_CAPTCHA_SITE_KEY
            });
        });

        // Show reCAPTCHA inside asset
        $('.js-recaptcha2').show();

        // Bind reCAPTCHA validation
        $wrapper.click('form button[type=submit]', () => {
            const reCaptchaResponse = window.grecaptcha.getResponse();
            const reCaptchaIsNotValid = reCaptchaResponse.length === 0;
            $('#g-recaptcha + input').prop('required', reCaptchaIsNotValid);
        });
    }
}

module.exports = {
    init: function () {
        (function () {
            document.addEventListener('keydown', function (e) {
                if (e.key === 'Tab') {
                    document.body.classList.add('keyboard-mode');
                }
            });

            document.addEventListener('mousedown', function () {
                document.body.classList.remove('keyboard-mode');
            });

            document.addEventListener('touchstart', function () {
                document.body.classList.remove('keyboard-mode');
            });
        })();
        returnForm();

        var $returnFormWrapper = $('.online-returns-box');
        initializeCaptcha($returnFormWrapper);
    }
};
